import { TemplatePageProps } from './types'
import { DominoesEntity } from './entity'
import Icon from 'images/games/dominoes/icon.png'
import Detail1 from 'images/games/dominoes/detail1.png'
import {
  DunkShotLink,
  MatchNFlipLink,
  NumbersBlitzLink,
  PlaySolitaireOnlineLink,
  Pocket7GamesLink,
  PoolClashLink,
  TileBlitzLink,
  TwentyOneGoldLink,
} from '../../components'
import { Pocket7GamesSwiper } from './pocket7games'

export const DominoesDetail: TemplatePageProps = {
  entity: {
    ...DominoesEntity,
    logo: Icon,
    title: 'Dominoes Game App: Experience the Best Online Tile Game',
    description: (
      <>
        There’s nothing like a good <strong>dominoes game</strong> to get your brain working and your competitive side
        fired up! With the <strong>dominoes game app</strong> in the <strong>Pocket7Games</strong> lineup, you can jump
        into a classic <strong>tile game</strong> anytime, right from your phone. Download Pocket7Games now and play
        wherever, whenever.
      </>
    ),
  },
  swiper: Pocket7GamesSwiper,
  content: [
    {
      title: 'How to Play the Dominoes Game Online',
      description: (
        <>
          This isn’t your old-school tabletop match—this <strong>online dominoes game</strong> is built for quick rounds
          and smart plays. You start with seven tiles, and the player with a double kicks things off. Match numbers on
          the board, and if your move adds up to a multiple of five, you score. Simple, right? But here’s the twist:
          blocking your opponent and clearing your hand first gets you even more points.
          <br />
          <br />
          If you’re stuck, draw from the Boneyard and stay in the game. First to hit 80 points takes the win. Whether
          you’re new or a seasoned pro, this <strong>tile game</strong> keeps you on your toes.
        </>
      ),
      image: Detail1,
    },
    {
      title: 'Play Tile Games and More in Pocket7Games',
      description: (
        <>
          If you’re into strategy, speed, and smart moves, this <strong>dominoes game app</strong> delivers. It’s
          smooth, it’s fast, and it’s way more than just matching tiles. You can <strong>play dominoes online</strong>{' '}
          for real money rewards—and even bragging rights.
          <br />
          <br />
          Once you’ve nailed dominoes, try other favorites in the{' '}
          <Pocket7GamesLink>
            <strong>Pocket7Games</strong> app
          </Pocket7GamesLink>
          , like <MatchNFlipLink />, <PlaySolitaireOnlineLink />, <TileBlitzLink />, <NumbersBlitzLink />,{' '}
          <PoolClashLink />, <DunkShotLink />, and <TwentyOneGoldLink />.
        </>
      ),
    },
  ],
} as TemplatePageProps
